import { useEffect, useRef } from 'react';
import type { ApiError } from '../api';
import controls from './controls.module.css';
import styles from './StatusScreens.module.css';

/** Tela cheia enquanto o servidor ainda não disse se há alguém conectado. */
export function LoadingScreen() {
  return (
    <main className={styles.screen}>
      <div role="status" className={styles.loading}>
        <span className={styles.spinner} aria-hidden="true" />
        <span>Carregando…</span>
      </div>
    </main>
  );
}

/**
 * Não deu para perguntar quem está conectado (rede, 5xx). NÃO é "deslogado": mandar a pessoa ao
 * login faria uma queda do servidor parecer perda de sessão. Oferece tentar de novo.
 */
export function SessionErrorScreen({ error, onRetry }: { error: ApiError; onRetry: () => void }) {
  const retryRef = useRef<HTMLButtonElement>(null);

  // A tela some durante a nova tentativa (volta o "Carregando…"); se falhar de novo, o foco
  // volta ao botão em vez de se perder no corpo da página.
  useEffect(() => {
    retryRef.current?.focus();
  }, []);

  return (
    <main className={styles.screen}>
      <div className={`${styles.panel} ${styles.card}`}>
        <h1 className={styles.title}>Não foi possível verificar sua sessão</h1>
        <p role="alert" className={styles.message}>
          {error.message}
        </p>
        <button type="button" ref={retryRef} className={controls.primary} onClick={onRetry}>
          Tentar de novo
        </button>
      </div>
    </main>
  );
}
